import { render, staticRenderFns } from "./PublishEventModal.vue?vue&type=template&id=12d739c5&"
import script from "./PublishEventModal.vue?vue&type=script&lang=js&"
export * from "./PublishEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports